import {
  Component,
  Input,
  Output,
  forwardRef,
  EventEmitter,
  OnInit,
} from '@angular/core'
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms'

@Component({
  standalone: false,
  selector: 'latitude-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
})
export class ToggleComponent implements OnInit {
  private _checked = false

  @Input()
  get checked(): boolean {
    return this._checked
  }
  set checked(value) {
    this._checked = value
  }

  @Input() label: string

  @Output() change = new EventEmitter()

  constructor() {}

  ngOnInit() {}

  toggleChecked() {
    this.checked = !this.checked
    this.change.emit(this.checked)
  }

  writeValue(value: any): void {
    this._checked = value
  }
}
